import {
  type PimABDASubstanceV1,
  PimABDASubstanceV1TypeEnum,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

interface ProductAccessorGetSubstances {
  activeSubstances: PimABDASubstanceV1[]
  additiveSubstances: PimABDASubstanceV1[]
}

export const productAccessorGetSubstances = (
  product: PimProductV11,
): ProductAccessorGetSubstances => {
  if (!product.substances || product.substances.length === 0) {
    return {
      activeSubstances: [],
      additiveSubstances: [],
    }
  }

  const activeSubstancesList = product.substances.filter(
    ({ type }) => type === PimABDASubstanceV1TypeEnum.ACTIVE,
  )

  const additiveSubstancesList = product.substances.filter(
    ({ type }) => type === PimABDASubstanceV1TypeEnum.ADDITIVE,
  )

  return {
    activeSubstances: activeSubstancesList,
    additiveSubstances: additiveSubstancesList,
  }
}
